import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Routes as routes } from '../navigation';
import { UserActions, NavigationActions, ContextActions, PracticeActions, NotificationsActions } from '../actions';
import { PracticeJoinRequests, PracticeEnterpriseMessage, PracticeLocations, PracticeProfile, PracticePaymentInfo, PracticeFrontDeskAccounts, PracticeInitialMessages, PracticeNotificationPreferences, TitleBar, NavBar, SubscriptionInfo } from  '../components'

class PracticeScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  componentDidMount() {
    this.props.contextActions.fetchDataForScreenAndRole('practice');
    this.props.practiceActions.getSelectedPractice();
  }

  renderContentContainers = () => {
    const selectedPracticeLocations = this.props.practice && this.props.practice.locations ? this.props.practice.locations : {};
    const selectedLocationsArray    = Object.keys(selectedPracticeLocations).map((location_id) => { return selectedPracticeLocations[location_id] });
    const joinRequestNotifications  = this.props.notifications && this.props.notifications.notificationsTypeDict && this.props.notifications.notificationsTypeDict['new_practice_join_request'] ? this.props.notifications.notificationsTypeDict['new_practice_join_request'] : [];
    const practice                  = this.props.practice && this.props.practice.practice ? this.props.practice.practice : {};
    const subscription              = this.props.practice && this.props.practice.practiceSubscription ? this.props.practice.practiceSubscription : {};
    const is_instant                = subscription && subscription.subscription && (subscription.subscription.subscription_type === 'INSTANT' || subscription.subscription.subscription_type === 'INSTANT_PAID');

    return <div className="flex-container screen-main-content">
        <div className="screen-container-column">
          <PracticePaymentInfo
            token={this.props.user.auth.token}
            bank={this.props.practice.bank}
            hide={is_instant}
            stripeAccount={this.props.practice.stripeAccount}
            practiceActions={this.props.practiceActions}
          />
          <PracticeProfile
            token={this.props.user.auth.token}
            selectedPractice={this.props.context.selectedPractice}
            practices={this.props.user.practices}
            practiceActions={this.props.practiceActions}
          />
          <PracticeNotificationPreferences
            hide={is_instant}
            preferences={this.props.practice.notificationPreferences}
            practiceActions={this.props.practiceActions}
          />
          <PracticeInitialMessages
            token={this.props.user.auth.token}
            hide={is_instant}
            locations={selectedLocationsArray}
            alerts={this.props.practice.alerts}
            practiceActions={this.props.practiceActions}
          />
        </div>
        <div className="screen-container-column">
          <PracticeEnterpriseMessage practice={practice} practiceActions={this.props.practiceActions} />
          <SubscriptionInfo
            token={this.props.user.auth.token}
            subscription={subscription}
            practiceActions={this.props.practiceActions}
          />
          <PracticeLocations
            locations={selectedLocationsArray}
            practiceActions={this.props.practiceActions}
            token={this.props.user.auth.token}
          />
          <PracticeFrontDeskAccounts
            hide={is_instant}
            token={this.props.user.auth.token}
            locations={selectedLocationsArray}
            frontDeskUsers={this.props.practice.frontDeskUsers}
            practiceActions={this.props.practiceActions}
          />
        </div>
      </div>
  }

  render() {
    return (
      <div className="flex-container flex-container-column flex-center-align">
        <TitleBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          practices={this.props.user.practices}
          userActions={this.props.userActions}
          practice={this.props.practice.practice}
        />
        <NavBar
          selectedPractice={this.props.context.selectedPractice}
          selectedRole={this.props.context.selectedRole}
          selectedTab={'my_account'}
          currentRoute={routes.PRACTICE}
          practice={this.props.practice.practice}
          notifications={this.props.notifications}
        />

        { this.renderContentContainers() }

      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    practice: state.practice,
    notifications: state.notifications,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    notificationsActions: bindActionCreators(
     { ...NotificationsActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PracticeScreen)
